import React from "react";

// Display-only integration catalogue. No real connections yet — clicking a
// card does nothing. Two categories per the product spec.
const WORK = [
  { name: "Trello", color: "#0079BF" },
  { name: "Jira", color: "#2684FF" },
  { name: "Asana", color: "#F06A6A" },
  { name: "ClickUp", color: "#7B68EE" },
  { name: "Linear", color: "#5E6AD2" },
];
const COMMS = [
  { name: "Email", color: "#EA4335" },
  { name: "Slack", color: "#611f69" },
  { name: "Microsoft Teams", color: "#5059C9" },
];

function Card({ name, color }) {
  return (
    <div className="flex items-center gap-3 rounded-xl border border-[#242A38] bg-[#151A24] p-4" data-testid={`integration-${name.split(" ")[0].toLowerCase()}`}>
      <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg text-[15px] font-bold text-white" style={{ background: color }}>{name[0]}</span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-[14px] font-semibold text-[#F4F5F8]">{name}</p>
        <p className="text-[12px] text-[#6E7686]">Coming soon</p>
      </div>
      <span className="rounded-full bg-[#1C2130] px-2.5 py-1 text-[11px] font-medium text-[#6E7686]">Soon</span>
    </div>
  );
}

function Section({ title, subtitle, items }) {
  return (
    <section>
      <h2 className="text-[15px] font-semibold text-[#F4F5F8]">{title}</h2>
      <p className="mt-0.5 text-[13px] text-[#6E7686]">{subtitle}</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">{items.map((i) => <Card key={i.name} {...i} />)}</div>
    </section>
  );
}

export default function Integrations() {
  return (
    <div className="animate-in fade-in duration-300">
      <h1 className="text-[22px] font-semibold tracking-tight text-[#F4F5F8]">Integrations</h1>
      <p className="mt-1 text-[14px] text-[#98A0B0]">Connect Pinlayr to the tools your team already uses.</p>
      <div className="mt-8 space-y-10">
        <Section title="Work management" subtitle="Turn tickets into tasks where work gets done." items={WORK} />
        <Section title="Communication" subtitle="Send review activity where your team talks." items={COMMS} />
      </div>
    </div>
  );
}
